/**
 * Campo de documento com máscara (CPF, CNPJ, CPF/CNPJ automático, RG, CEP, PIS).
 *
 * Mesmo contrato do `CampoTelefone`: a máscara vive na tela e emite o valor
 * **normalizado** (só dígitos) via `onChange`. O que se digita aparece formatado; o
 * que sai para o backend é limpo. Identificador → mono (manual §2).
 */
import { useId } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { desformatar, type Formato, formatar } from '@/lib/mascaras';

export function CampoDocumento({
  rotulo,
  valor,
  onChange,
  formato,
  id,
  obrigatorio,
  placeholder,
}: {
  rotulo: string;
  /** Valor normalizado (só dígitos, ou placa alfanumérica). Vazio quando não há. */
  valor: string;
  onChange: (normalizado: string) => void;
  formato: Formato;
  id?: string;
  obrigatorio?: boolean;
  placeholder?: string;
}) {
  const gerado = useId();
  const campoId = id ?? gerado;

  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={campoId}>{rotulo}</Label>
      <Input
        id={campoId}
        inputMode={formato === 'rg' ? 'text' : 'numeric'}
        required={obrigatorio}
        placeholder={placeholder}
        className="font-mono"
        value={formatar(valor, formato)}
        onChange={(e) => onChange(desformatar(e.target.value, formato))}
      />
    </div>
  );
}
